/* tslint:disable */
export var PlatformType;
(function (PlatformType) {
    PlatformType[PlatformType["UNKNOWN"] = 0] = "UNKNOWN";
    PlatformType[PlatformType["WEB"] = 1] = "WEB";
    PlatformType[PlatformType["IOS"] = 2] = "IOS";
    PlatformType[PlatformType["ANDROID"] = 3] = "ANDROID";
    PlatformType[PlatformType["FACEBOOK"] = 4] = "FACEBOOK";
    PlatformType[PlatformType["STEAM"] = 5] = "STEAM";
    PlatformType[PlatformType["EDITOR"] = 6] = "EDITOR";
    PlatformType[PlatformType["STANDALONE"] = 7] = "STANDALONE";
    PlatformType[PlatformType["FACEBOOK_ARCADE"] = 8] = "FACEBOOK_ARCADE";
    PlatformType[PlatformType["AMAZON"] = 9] = "AMAZON";
})(PlatformType || (PlatformType = {}));
/* tslint:enable */



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/types/PlatformTypeEnum.ts
// module id = 410
// module chunks = 3